import { useMutation } from '@tanstack/react-query';
import type { CreateWorkflowVersionPayload } from '~/helpers/api-new/modules/workflows/workflowsApi';
import useAPI from '~/helpers/api-new/context';

export function useCreateWorkflowVersion() {
  const { workflows } = useAPI();
  return useMutation({
    mutationFn:
    (payload: CreateWorkflowVersionPayload) => workflows.versions.createWorkflowVersion(payload),
  });
}

